import { render, staticRenderFns } from "./ClientModifier.vue?vue&type=template&id=2bf72f35&"
import script from "./ClientModifier.vue?vue&type=script&lang=js&"
export * from "./ClientModifier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports